import {
  createExerciseCatalogSource,
  type CatalogSnapshot,
  type ExerciseCatalogSource,
} from "@heraion/shared";

import { apiFetchConditional } from "../api";
import { storedClaims } from "../auth/cognito";
import { lsCache } from "../lsCache";
import { webStorage } from "../webStorage";

// web-rnw's catalog source: the localStorage twin of
// apps/mobile/src/state/exercisesCache.ts's AsyncStorage mirror. The fetch
// and the cache policy are the SAME @heraion/shared
// createExerciseCatalogSource; only the storage adapter differs.
// v2 (#342): pages with their ETags, plus the owner.

const cache = lsCache<unknown>("logger/exercisesCache.v2");
const OLD_KEY = "logger/exercisesCache.v1";

const owner = (): string | null => {
  const sub = storedClaims()?.["sub"];
  return typeof sub === "string" ? sub : null;
};

/** Every catalog read on web-rnw goes through this one instance. */
export const exerciseCatalog: ExerciseCatalogSource =
  createExerciseCatalogSource({
    get: apiFetchConditional,
    owner,
    store: {
      read: () => {
        try {
          webStorage.removeItem(OLD_KEY);
        } catch {
          // private mode: nothing to clean
        }
        return cache.read();
      },
      write: (snapshot: CatalogSnapshot) => cache.write(snapshot),
    },
  });
